var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRunner = function SvgRunner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "runner_svg__a",
    width: 20,
    height: 21,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .409h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#runner_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57565C",
    d: "M11.042 19.368v-4.864l-2.087-1.995-.865 3.826-5.35-1.086.253-1.242 4 .825L8.44 7.473l-1.98.8v2.761h-1.25v-3.58l3.307-1.4q.633-.266.933-.35.3-.087.55-.086.382 0 .71.2a1.6 1.6 0 0 1 .531.537l.833 1.333a4.55 4.55 0 0 0 1.461 1.446 4.16 4.16 0 0 0 2.09.634v1.25a5.7 5.7 0 0 1-2.456-.653q-1.186-.613-2.022-1.775l-.62 3.133 1.765 1.7v5.945zm.208-14.504q-.64 0-1.09-.45-.449-.449-.449-1.088 0-.64.45-1.09.45-.449 1.089-.449.64 0 1.089.45.45.45.45 1.089 0 .64-.45 1.089-.45.45-1.09.45"
  }))));
};
export default SvgRunner;